export class StaticGlobals {
    static netPrices: boolean;
    static roundTo5Cent: boolean;
}
